import { DetailsList } from '@almbrand/detailslist'; // Base DetailsList component
import React from 'react';

export interface DetailsListComponentProps {
	detailsList: {
		label: string;
		value: string;
		highlight?: boolean;
	}[]; // Array of detail items
	highlightDetails?: boolean; // Option to highlight details
	className?: string; // Additional class for styling
}

export const DetailsListComponent: React.FC<DetailsListComponentProps> = ({
	detailsList,
	highlightDetails = false,
	className, // Accept className prop for styling
}) => {
	return (
		<div className={`${className || ''}`}>
			{/* Apply styling */}
			<DetailsList
				boxed={true}
				detailsList={detailsList.map((item) => ({
					primaryItem: item.label,
					secondaryItem: item.value,
					highlight: highlightDetails ? item.highlight : false, // Apply highlight logic
				}))}
				highlightDetails={highlightDetails}
			/>
		</div>
	);
};
